<template>
    <section id="common_author_area" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="common_author_boxed">
                        <div class="common_author_heading">
                            <h3>{{ $t('forgot_password') }}</h3>
                            <h2>{{ $t('reset_your_password') }}</h2>
                        </div>
                        <div class="common_author_form">
                            <div class="form-group">
                                <input type="text" v-model="email" class="form-control" :placeholder="$t('email')" />
                                <p>{{ message }}</p>
                            </div>
                            <div class="common_form_submit">
                                <button type="button" class="btn btn_theme btn_md" @click="sendResetEmail">{{ $t('send_link')
                                }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { ref } from 'vue'
    import axios from 'axios'
    import { API_BASE_URL, FORGOT_PASSWORD } from "@/api-config";


    export default {
        name: 'ForgotPassword',
        setup() {
            const email = ref('')
            const message = ref('')

            const sendResetEmail = async () => {
                message.value = ''

                if (!email.value) {
                    message.value = $t('validation.email_required')
                    return
                }
            
                try {
                    const response = await axios.post(`${API_BASE_URL}${FORGOT_PASSWORD}`, {
                        email: email.value
                    })
                    message.value = response.data.message
                    if(response.status === 200) {
                        email.value = ''
                    }
                } catch (error) {
                    message.value = error.response?.data?.message || 'Error al enviar el enlace'

                }
            }

            return {
                email,
                message,
                sendResetEmail
            }
        }
    }
</script>